import { type Theme } from '@direct-frontend/components';
import { kitDarkTheme, kitLightTheme } from '../themekit';
import { useThemeColor } from './useThemeColor';

export const useTheme = (): Theme => (useThemeColor() === 'dark' ? kitDarkTheme : kitLightTheme);
